import {
    AfterViewChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { delay, filter, take } from 'rxjs/operators';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { SubSink } from 'subsink';

import { FilenetNestedTreeControl } from './filenet.treecontrol';
import { FilenetNestedDataSource } from './filenet.treedatasource';

@Component({
    selector: 'filenet-tree',
    templateUrl: 'filenet-tree.component.html',
    styleUrls: ['filenet-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilenetTreeComponent
    implements OnInit, OnChanges, AfterViewChecked, OnDestroy {
    @Input() folder: Folder;
    @Input()
    objectStore: string;

    subs = new SubSink();
    needToScrollAgain = true;

    loading$ = this.folderService.loading$;

    folderEntities$ = this.folderService.entities$;

    treeControl: FilenetNestedTreeControl;
    dataSource: FilenetNestedDataSource<Folder>;

    lastScroll = '';

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    addExpandedParents = (folder: Folder) => {
        // console.log('Expanding Folder', folder);
        this.treeControl.addExpandedId(folder.id);

        if (folder.parentID) {
            this.folderService
                .getByID(this.objectStore, folder.parentID)
                .pipe(take(1))
                .subscribe(v => this.addExpandedParents(v));
        } else {
            // this.needToScrollAgain = true;
            this.scollToFolder();
        }
    };

    displayChanges = () => {
        // console.log('Changed', this.folder, this.treeControl);
        if (this.folder && this.folder.parentID && this.treeControl) {
            // console.log('Expainding');
            // this.treeControl.addExpandedId(this.folder.id);
            // this.treeControl.addExpandedId(this.folder.parentID);
            // this.needToScrollAgain = true;
            this.addExpandedParents(this.folder);
        }
    };

    ngOnChanges(changes: SimpleChanges): void {
        // console.log('ngOnChanges');
        this.displayChanges();
    }

    ngAfterViewChecked() {
        // console.log('ngAfterViewChecked', this.needToScrollAgain);
        if (this.needToScrollAgain && !!this.folder) {
            this.scollToFolder();
        }
    }

    scollToFolder() {
        of('t')
            .pipe(delay(1))
            .subscribe(v => {
                const el = document.getElementById(this.folder.id);
                // console.log('GOT FOR SCROLL', el, this.folder.id);
                if (el) {
                    // console.log('Scrolling to ', this.folder.id);
                    el.scrollIntoView();
                    // console.log('And we have scrolled');
                    this.needToScrollAgain = false;
                }
            });
    }

    ngOnInit() {
        // console.log('INIT', this.needToScrollAgain);
        this.treeControl = new FilenetNestedTreeControl(
            this.folderService,
            this.objectStore
        );
        // this.treeControl.changed.subscribe(v => {
        //     console.log('Tree Control Changed');
        //     this.needToScrollAgain = true;
        // });
        if (!this.dataSource) {
            this.dataSource = new FilenetNestedDataSource(
                this.folderService,
                this.objectStore
            );
        }

        this.displayChanges();

        this.subs.add(
            this.folderEntities$
                .pipe(filter(v => !!this.folder))
                .subscribe(v => {
                    this.needToScrollAgain = true;
                    // console.log('Need to scroll again, ENTITIES');
                    // this.scollToFolder();
                })
        );
    }

    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private folderService: FolderService,
        private cdr: ChangeDetectorRef
    ) {}
    hasChild = (_: number, node: Folder) =>
        node && !!node.subFolders && node.subFolders.length > 0;

    selectFolder = (node: Folder) => {
        // console.log('SELECT FOLDER', node);
        this.router.navigate(['FolderDetail', node.id], {
            relativeTo: this.activeRoute,
        });
    };

    isSelected = (node: Folder) => {
        return node && this.folder && this.folder.id === node.id;
    };

    getName = (node: Folder) => {
        if (!node || !node.propertiesObj) {
            return '';
        } else {
            return node.propertiesObj.FolderName;
        }
    };

    getDescription = (node: Folder) => {
        if (!node || !node.propertiesObj) {
            return '';
        } else if (!node.propertiesObj.FolderDescription) {
            return node.propertiesObj.FolderName;
        } else {
            return node.propertiesObj.FolderDescription;
        }
    };
}
